import request from '@/utils/request.js'
import Config from '@/config/app.js'

let wxUseUrl = Config.wxUseUrl;
console.log('wxUseUrl', wxUseUrl)

/**
 * 获取身份证信息
 * @param params
 * @returns {AxiosPromise}
 */
export function getIdcard(params) {
    return request({
        closeInterceptors: true,
        url: wxUseUrl + 'ocr/idcard',
        method: 'post',
        data: params
    })
}

/**
 * 职业认证
 * @param params
 * @returns {AxiosPromise}
 */
export function getZyzsOcr(params) {
    return request({
        closeInterceptors: true,
        // url: wxUseUrl + 'ocr/zyzsOcr',
        url: wxUseUrl + 'ocr/tmOcr',
        method: 'post',
        data: params
    })
}

/**
 * 网络图片转base64
 * @param params
 * @returns {AxiosPromise}
 */
export function urlToBase64(params) {
    return request({
        closeInterceptors: true,
        url: wxUseUrl + 'pub/urlToBase64',
        method: 'post',
        data: params
    })
}


